module.exports = __webpack_public_path__ + "static/img/avatar.ecba1844.gif";